<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>{{ mode == "create" ? "Create Rent" : "Edit Rent " }}</p>
      </div>
      <div class="cover">
        <div class="row mt-4" v-if="mode === 'create'">
          <div class="col-md-6">
            <div
              class="card cursor-pointer"
              @click="mode === 'create' ? changeTab('newUser') : null"
            >
              <div
                class="card-body text-center br-7"
                :class="[tab == 'newUser' ? 'activeCard' : null]"
              >
                <img src="@/assets/img/profile-user.png" width="50" />
                <h5 class="card-text font-bold mt-3">
                  {{ $t("text.bLease.newUser") }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="card cursor-pointer"
              @click="mode === 'create' ? changeTab('oldUser') : null"
            >
              <div
                class="card-body text-center"
                :class="[tab == 'oldUser' ? 'activeCard' : null]"
              >
                <img src="@/assets/img/profile-user.png" width="50" />
                <h5 class="font-bold mt-3 card-text">
                  {{ $t("text.bLease.existingUser") }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="personal mt-4">
          <h5>{{ $t("text.bLease.leaseInfo") }}</h5>
          <div class="row">
            <div
              class="input__group__block mt-4 col-md-6"
              v-if="mode === 'create'"
            >
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cashflow.selectStation") }}</span
                >
              </label>
              <div class="price_change_input_wrapper">
                <model-select
                  :options="branches"
                  v-model="branchId"
                  :placeholder="$t('text.cBranchLease.selectBranch')"
                >
                </model-select>
              </div>
            </div>

            <div
              class="input__group__block mt-4 col-md-6"
              v-if="mode === 'create'"
            >
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.rentPaid") }}</span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  placeholder="Rent  paid"
                  v-model="rentPaid"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.rentDate") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <vue-ctk-date-time-picker
                  v-model="formData.rentDate"
                  :onlyDate="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.selectDate')"
                />
              </div>
            </div>
            <!-- <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.exDate") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <vue-ctk-date-time-picker
                  v-model="formData.expiryDate"
                  :onlyDate="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.selectDate')"
                />
              </div>
            </div> -->
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.availableBs") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <model-select
                  :options="branchSpaces"
                  v-model="formData.branchSpaceID"
                  :placeholder="
                    spacesLoader ? 'Loading...' : $t('text.bLease.selectBS')
                  "
                >
                </model-select>
              </div>
            </div>
            <div
              class="input__group__block mt-4 col-md-6"
              v-if="formData.branchSpaceID"
            >
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.selectRentDur") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <model-select
                  :options="rentDurations"
                  v-model="rentDuration"
                  :placeholder="
                    durationLoader ? 'Loading...' : 'select rent duration'
                  "
                >
                </model-select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6" v-if="rentDuration">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.rentDurLength") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.bLease.rentDurLength')"
                  v-model="rentDurationLength"
                  class="border-0"
                />
              </div>
            </div>
            <div
              class="input__group__block mt-4 col-md-6"
              v-if="tab === 'oldUser'"
            >
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.bLease.availableOccupants") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <model-select
                  :options="occupants"
                  v-model="formData.occupantID"
                  :placeholder="$t('text.bLease.seleceOcc')"
                >
                </model-select>
              </div>
            </div>
            <div
              class="input__group__block mt-4 col-md-6"
              v-if="tab === 'oldUser' && $route.params.leaseId"
            >
              <label class="required">
                <span class="mylabel"> {{ $t("text.bLease.leasedBy") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.bLease.leasedBy')"
                  v-model="leasedBy"
                  class="border-0"
                />
              </div>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
        <div class="personal mt-4" v-if="tab === 'newUser'">
          <h5>{{ $t("text.bLease.userDetails") }}</h5>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.form.fullName") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.form.fullName')"
                  v-model="formData.userDetail.fullName"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.form.email") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.form.email')"
                  v-model="formData.userDetail.email"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">{{ $t("text.form.address") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.form.address')"
                  v-model="formData.userDetail.address"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t("text.form.phoneNo") }} </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.form.phoneNo')"
                  v-model="formData.userDetail.phoneNumber"
                  class="border-0"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-4 pb-4">
          <button
            :disabled="isButtonDisabled ? true : false"
            class="ep-btn ep-primary"
            @click="
              mode === 'create'
                ? createBranchLease($event)
                : updateLease($event)
            "
          >
            {{ mode == "create" ? "Create" : "Update" }}
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import JQuery from "jquery";
import { BIconChatLeftTextFill } from "bootstrap-vue";
let $ = JQuery;

export default {
  title: "Create branch lease :: Epump Portal",
  name: "CreateBranchLease",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
    ModelSelect,
  },
  data() {
    return {
      companyId: null,
      company: null,
      branches: [],
      branchId: null,

      branch: "",
      tab: "newUser",
      spacesLoader: false,
      durationLoader: false,
      occupants: [],
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      leasedBy: "",
      rentPaid: 0,
      formData: {
        rentDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
        expiryDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
        branchSpaceID: "",
        occupantID: "",
        userDetail: {
          fullName: "",
          email: "",
          address: "",
          phoneNumber: "",
        },
      },
      branchSpaces: [],
      branchSpace: "",
      mode: "create",
      isButtonDisabled: false,
      rentDurations: [],
      rentDuration: null,
      rentDurationLength: null,
    };
  },
  // created() {
  //   this.$eventHub.$on("branch", (branch) => {
  //     this.branch = branch;
  //     document.title = `Create Branch Lease :: ${branch.name} Retail Outlet`;
  //   });
  // },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
      this.getBranches();
    }
  },
  watch: {
    company(company) {
      if (company !== null) {
        console.log(company, "jjjj");
        this.companyId = company.id;
        this.getBranches();
      }
    },
    "formData.branchSpaceID": {
      handler() {
        this.getRentDurations();
      },
      deep: true,
    },
    branchId: function (newBranch, oldBranch) {
      if (newBranch) {
        if (this.branchId !== null) {
          this.getBranchSpaces();
          this.getBranchOccupants();
        }
      }
    },
  },

  mounted() {
    if (this.$route.query.leaseId && this.$route.query.create !== "yes") {
      this.mode = "edit";
      this.tab = "oldUser";
      this.getBranchLease();
    }
  },
  beforeDestroy() {},
  methods: {
    //Requests
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${this.companyId}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });

          this.branches = res.data;
          this.branches.forEach((el) => {
            el.text = el.name;
            el.value = el.id;
          });
        })
        .catch((error) => {});
    },
    getBranchSpaces() {
      this.spacesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/All/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          const newData = response.data.filter(
            (data) => data.isAvailable === true
          );
          newData.forEach((el) => {
            el.text = el.name;
            el.value = el.id;
          });
          this.branchSpaces = newData;
        })
        .catch((error) => {
          this.spacesLoader = false;
        })
        .finally(() => {
          this.spacesLoader = false;
        });
    },
    getRentDurations() {
      this.durationLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/RentDuration/${this.formData.branchSpaceID}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.value = el.id;
            el.text = `${el.name} - ${
              this.branch ? this.branch.currencyCode : ""
            } ${el.durationPrice}`;
          });
          this.rentDurations = response.data;
        })
        .catch((error) => {
          this.durationLoader = false;
        })
        .finally(() => {
          this.durationLoader = false;
        });
    },
    getBranchLease() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Lease/Get/${this.$route.params.leaseId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.formData.rentDate = response.data.rentdate;
          this.formData.expiryDate = response.data.expiryDate;
          this.formData.branchSpaceID = response.data.branchSpaceID;
          this.formData.occupantID = response.data.occupantID;
          this.leasedBy = response.data.leasedBy;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    changeTab(tab) {
      this.tab = tab;
    },
    createBranchLease($event) {
      $event.preventDefault();
      if (!this.rentPaid) {
        this.$toast.open({
          message: this.$t("text.bLease.rentPaidRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      for (let [key, value] of Object.entries(this.formData)) {
        if (key !== "userDetail") {
          if (this.tab === "oldUser" && key === "occupantID") {
            if (!value) {
              this.$toast.open({
                message: `${key} ${$t("text.bLease.isRequest")}`,
                type: "error",
                duration: 5000,
              });
              return;
            }
          } else if (this.tab === "oldUser" && key !== "occupantID" && !value) {
            this.$toast.open({
              message: `${key} ${$t("text.bLease.isRequest")}`,
              type: "error",
              duration: 5000,
            });
            return;
          } else {
            if (!value) {
              if (key === "occupantID" && !value && this.tab === "newUser") {
                continue;
              } else {
                this.$toast.open({
                  message: `${key} ${$t("text.bLease.isRequest")}`,
                  type: "error",
                  duration: 5000,
                });
                return;
              }
            }
          }
        }
        if (this.tab === "newUser") {
          if (key === "userDetail") {
            for (let [prop, value] of Object.entries(this.formData[key])) {
              if (!value) {
                this.$toast.open({
                  message: `${prop} ${$t("text.bLease.isRequest")}`,
                  type: "error",
                  duration: 5000,
                });
                return;
              }
            }
          }
        }
      }

      if (!this.rentDuration) {
        this.$toast.open({
          message: this.$t("text.bLease.rentDurationRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.rentDurationLength) {
        this.$toast.open({
          message: this.$t("text.bLease.rentDurLenRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data;
      if (this.tab === "newUser") {
        data = {
          rentPaid: Number(this.rentPaid),
          rentDate: this.formData.rentDate,
          expiryDate: this.formData.expiryDate,
          branchSpaceID: this.formData.branchSpaceID,
          userDetail: this.formData.userDetail,
          rentDuration: this.rentDuration,
          rentDurationLength: Number(this.rentDurationLength),
        };
      } else {
        data = {
          rentPaid: Number(this.rentPaid),
          rentDate: this.formData.rentDate,
          expiryDate: this.formData.expiryDate,
          branchSpaceID: this.formData.branchSpaceID,
          occupantID: this.formData.occupantID,
          rentDuration: this.rentDuration,
          rentDurationLength: Number(this.rentDurationLength),
        };
      }

      this.isButtonDisabled = true;
      let url;
      if (this.tab === "newUser") {
        url = `${configObject.apiBaseUrl}/Lease/CreateLease/NewUser`;
      } else {
        url = `${configObject.apiBaseUrl}/Lease/CreateLease/ExistingUser`;
      }
      $(".loader").show();
      this.axios
        .post(url, data, configObject.authConfig())
        .then(() => {
          this.$router.push({
            name: "CompanyLease",
            query: {
              companyId: this.$route.query.companyId,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
            },
          });
          this.$toast.open({
            message: this.$t("text.bLease.successfullyCreatedBL"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    updateLease($event) {
      $event.preventDefault();
      if (!this.leasedBy) {
        this.$toast.open({
          message: this.$t("text.bLease.leasedByRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      for (let [key, value] of Object.entries(this.formData)) {
        if (key !== "userDetail") {
          if (this.tab === "oldUser" && key === "occupantID") {
            if (!value) {
              this.$toast.open({
                message: `${key} ${$t("text.bLease.isRequest")}`,
                type: "error",
                duration: 5000,
              });
              return;
            }
          } else if (this.tab === "oldUser" && key !== "occupantID" && !value) {
            this.$toast.open({
              message: `${key} ${$t("text.bLease.isRequest")}`,
              type: "error",
              duration: 5000,
            });
            return;
          } else {
            if (!value) {
              if (key === "occupantID" && !value && this.tab === "newUser") {
                continue;
              } else {
                this.$toast.open({
                  message: `${key} ${$t("text.bLease.isRequest")}`,
                  type: "error",
                  duration: 5000,
                });
                return;
              }
            }
          }
        }
        if (this.tab === "newUser") {
          if (key === "userDetail") {
            for (let [prop, value] of Object.entries(this.formData[key])) {
              if (!value) {
                this.$toast.open({
                  message: `${prop} ${$t("text.bLease.isRequest")}`,
                  type: "error",
                  duration: 5000,
                });
                return;
              }
            }
          }
        }
      }

      let data = {
        rentDate: this.formData.rentDate,
        expiryDate: this.formData.expiryDate,
        branchSpaceID: this.formData.branchSpaceID,
        occupantID: this.formData.occupantID,
        leasedBy: this.leasedBy,
      };
      if (!this.leasedBy) {
        this.$toast.open({
          message: this.$t("text.bLease.leasedByRequired"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/Lease/Edit/Lease/${this.$route.params.leaseId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            name: "branch_Lease",
            query: {
              companyId: this.$route.query.companyId,
              branchId: this.$route.query.branchId,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
            },
          });
          this.$toast.open({
            message: this.$t("text.bLease.successfullyUpdatedBL"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getBranchOccupants() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Occupant/Get/All/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.text = `${el.firstName} ${el.lastName}`;
            el.value = el.id;
          });
          this.occupants = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
